import { useEffect } from "react";
import { usePageTitleContext } from "../../../contexts/PageTitleContext";
import "./AdnPageTitle.css";

const AdnPageTitle = ({ title }) => {
  const { updatePageTitle } = usePageTitleContext();

  useEffect(() => {
    updatePageTitle(title);
  }, [title, updatePageTitle]);

  return <></>;
};

export default AdnPageTitle;
